<template>
  <div class="static-menu bg-white">
    <ul class="py-4">
      <li v-for="page in props.pages" :key="page.key" class="w-294px hover:text-red-30">
        <locale-link class="block py-4 px-5 transition-colors" :to="`/${page.key}`" exact-active-class="text-red-50">{{
          $t(page.title)
        }}</locale-link>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  pages: { key: string; title: string }[]
}>()
</script>
